import { render, staticRenderFns } from "./PlayerInRoom.vue?vue&type=template&id=59ad80c3&"
import script from "./PlayerInRoom.vue?vue&type=script&lang=js&"
export * from "./PlayerInRoom.vue?vue&type=script&lang=js&"
import style0 from "./PlayerInRoom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports